module.exports = __webpack_public_path__ + "img/nullMessageInform.941f5d94.svg";